export function normalizeClientWebsite(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }
  if (!/^https?:\/\//i.test(trimmed)) {
    return `https://${trimmed}`;
  }
  return trimmed;
}

export const STUDIO_MIGRATION_WEBSITE_REQUIRED_MESSAGE =
  'Add a website to this client before migrating to Studio.';

export function isClientWebsiteMigratable(website?: string | null): boolean {
  const trimmed = (website ?? '').trim();
  if (!trimmed) {
    return false;
  }

  try {
    const url = new URL(/^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`);
    const hostname = url.hostname;
    return Boolean(hostname && hostname.includes('.'));
  } catch {
    return false;
  }
}

export function isValidClientWebsite(value: string): boolean {
  const normalized = normalizeClientWebsite(value);
  if (!normalized) {
    return true;
  }
  try {
    const url = new URL(normalized);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}
